import { FaTimes, FaUserPlus } from "react-icons/fa";
import { IUserShort } from "../../api/services/project.service";
import { ITeamMembership } from "../../api/services/team.service";
import GenericDialog from "../shared/GenericDialog";
import UserMembershipSection from "./UserMembershipSection";

export default function MemberDialog({
  isOpen,
  setIsOpen,
  members,
  fetchMembers,
  users,
  addMember,
  removeMember,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  members: ITeamMembership[];
  fetchMembers: () => void;
  users: IUserShort[];
  addMember: (userId: string, teamRole: string) => void;
  removeMember: (userId: string) => void;
}) {
  return (
    <>
      <GenericDialog
        onUpperRightClick={() => setIsOpen(false)}
        upperRightIcon={
          <FaTimes size={20} className="text-gray-600 dark:text-gray-300" />
        }
        header="Team Member"
        headerIcon={<FaUserPlus size={20} />}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      >
        <UserMembershipSection
          currentMembers={members}
          allUsers={users}
          addMember={addMember}
          removeMember={removeMember}
          fetchCurrentMembers={fetchMembers}
        />
      </GenericDialog>
    </>
  );
}
